import { api } from './api';

export function fetchResource(dispatch, resource, action) {
  return api.get(`/api/${resource}`).then(response => {
    dispatch({ type: action, payload: response.data });
    return response;
  });
}

export function updateResource(dispatch, resource, payload, action) {
  return api.put(`/api/${resource}`, payload).then(response => {
    return dispatch({ type: action, payload: response.data });
  });
}
